import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

const meta = {
	description: 'Learn about blueshyft’s story',
	image: '/images/new/misc/blueshyft-meta.png',
	title: 'Our Story | blueshyft',
	url: 'http://blueshyft.com.au/about',
};

import '../../css/about.css';

export default class About extends Component {
	render () {

		return (
			<React.Fragment>
				<Helmet
					title={meta.title}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="about-story">

					<div className="container">

						<h3>From humble beginnings...</h3>

						<div className="columns">

							<p>Launched in mid-2015, blueshyft began as an answer to technical and operational difficulties in the 
							Australian logistics space, with a bespoke iOS-based platform installed in just 500 news & convenience stores 
							across the country. Since then the network has tripled, and blueshyft has rapidly evolved into a universal 
							point-of-sale platform that connects a range of online businesses like Ladbrokes, Bitcoin Australia, 
							News Corp and Goget to their customers.</p>

							<p>Today, blueshyft is Australia’s most advanced in-store payment gateway. A national network of 
								over 1,500+ retailer locations is equipped with blueshyft’s iOS platform, enabling customers to 
								pay for digital goods and services via an in-store iPad. Since launching in 2015, blueshyft has 
								partnered with over 20 enterprise clients and processing millions of transactions and 
								executing hundreds of millions of dollars in payments.</p>

						</div>

					</div>

				</section>


				<section className="team">

					<h3>Meet the blueshyft team</h3>

					<p>Here at blueshyft, we work closely to deliver a seamless platform. With a diverse range of backgrounds 
						and experiences, the blueshyft team is committed to leveraging skill and talent to build great tech 
						and drive sustainable growth for our partners and retailers.</p>

					<div className="headshots">

						<div className="about-tile">
							<img src="/images/new/staff/matt.jpeg" style={{ borderRadius: '50%' }} />
							<div>
								<h4>MATT HANDBURY</h4>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<h5 style={{ marginRight: 5 }}>CHAIRMAN</h5>
									<a target="_blank" href="https://www.linkedin.com/in/matt-handbury-053a3b2a/">
										<img src="/images/new/icons/blu-linkedin.svg" style={{ margin: 0 }} />
									</a>
								</div>
							</div>
						</div>

						<div className="about-tile">
							<img src="/images/new/staff/kain-new.png" style={{ borderRadius: '50%' }} />
							<div>
								<h4>KAIN WARWICK</h4>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<h5 style={{ marginRight: 5 }}>NON EXECUTIVE DIRECTOR</h5>
									<a target="_blank" href="https://www.linkedin.com/in/kainwarwick/">
										<img src="/images/new/icons/blu-linkedin.svg" style={{ margin: 0 }} />
									</a>
								</div>
							</div>
						</div>
					
						<div className="about-tile">
							<img src="/images/new/staff/jamie-new.png" style={{ borderRadius: '50%', maxWidth: 177 }} />
							<div>
								<h4>JAMIE PATTERSON</h4>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<h5 style={{ marginRight: 5 }}>CHIEF EXECUTIVE OFFICER</h5>
									<a target="_blank" href="https://www.linkedin.com/in/pattersonjamie/">
										<img src="/images/new/icons/blu-linkedin.svg" style={{ margin: 0 }} />
									</a>
								</div>
							</div>
						</div>

						<div className="about-tile">
							<img src="/images/new/staff/hooms.png"/>
							<div>
								<h4>HOOMAN MOMTAZI</h4>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<h5 style={{ marginRight: 5 }}>HEAD OF OPERATIONS</h5>
									<a target="_blank" href="https://www.linkedin.com/in/hoomanmomtazi/">
										<img src="/images/new/icons/blu-linkedin.svg" style={{ margin: 0 }} />
									</a>
								</div>
							</div>
						</div>

						<div className="about-tile">
							<img src="/images/new/staff/denis.png"/>
							<div>
								<h4>DENIS GRISHIN</h4>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<h5 style={{ marginRight: 5 }}>HEAD OF PRODUCT</h5>
									<a target="_blank" href="https://www.linkedin.com/in/denis-grishin/">
										<img src="/images/new/icons/blu-linkedin.svg" style={{ margin: 0 }} />
									</a>
								</div>
							</div>
						</div>

						{/* <div className="about-tile">
							<img src="/images/new/staff/shivang.png"/>
							<div>
								<h4>SHIVANG KOTAK</h4>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<h5 style={{ marginRight: 5 }}>HEAD OF FINANCE</h5>
									<a target="_blank" href="https://www.linkedin.com/in/shivang-kotak-005682b1/">
										<img src="/images/new/icons/blu-linkedin.svg" style={{ margin: 0 }} />
									</a>
								</div>
							</div>
						</div> */}
						
						{/* <div className="about-tile">
							<img src="/images/new/staff/denis.png"/>
							<h4>DENIS GRISHIN</h4>
							<h5>PRODUCT MANAGER</h5>
						</div>

						<div className="about-tile">
							<img src="/images/new/staff/lina.png"/>
							<h4>LINA LUKOSIUNAITE</h4>
							<h5>OPERATIONS MANAGER</h5>
						</div>
					
						<div className="about-tile">
							<img src="/images/new/staff/rhiannon.png"/>
							<h4>RHIANNON STEVENSON</h4>
							<h5>SALES & MARKETING COORDINATOR</h5>
						</div>

						<div className="about-tile">
							<img src="/images/new/staff/zoe.png"/>
							<h4>ZOE ARCHER</h4>
							<h5>UX/UI DESIGNER &</h5>
							<h5>FRONT-END DEVELOPER</h5>
						</div>
					
						<div className="about-tile">
							<img src="/images/new/staff/sergey.png"/>
							<h4>SERGEY VASSILYEV</h4>
							<h5>FULL-STACK DEVELOPER</h5>
						</div>
					
						<div className="about-tile">
							<img src="/images/new/staff/rj.png"/>
							<h4>RJ BERNALDO</h4>
							<h5>DEVELOPER</h5>
						</div>
							
						<div className="about-tile">
							<img src="/images/new/staff/edie.png"/>
							<h4>EDIE WARNE</h4>
							<h5>MARKETING COORDINATOR</h5>
						</div>

						<div className="about-tile">
							<img src="/images/new/staff/jacob.png"/>
							<h4>JACOB MONSONEGO</h4>
							<h5>AGENT ACQUISITIONS LEAD</h5>
						</div>  */}

					</div>

				</section>

			</React.Fragment>
		);
	}
};



// WEBPACK FOOTER //
// ./client/scenes/About/index.js